import React, { Component } from "react";
import actions from '../actions';
import { connect } from 'react-redux';
import ObjectUtils from '../../../baseApp/shared/utils/ObjectUtils';
import MeetingRoomsScheduleEvents from './../components/MeetingRoomsScheduleEvents';

class MeetingRoomsScheduleEventsContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            universalSearchField: "",
            searchFieldsValues: {
                type: {
                    value: "",
                },
                origin: {
                    value: ""
                }
            }
        }
    }

    componentDidMount() {
        const {
            table: {
                sort,
            }
        } = this.props;

        this.fetchData(undefined, undefined, sort.property, sort.direction);
    }

    fetchData = (currentPage, pageSize, sortProperty, sortDirection) => {
        const {
            searchFieldsValues,
            universalSearchField
        } = this.state;

        const {
            meetingRoomId,
            searchScheduleEventEntries
        } = this.props;

        let filter = Object.entries(searchFieldsValues).reduce((acc, keyValuePair) => {
            return ObjectUtils.isNilOrEmpty(keyValuePair[1].value) ?
                {...acc} : {...acc, [keyValuePair[0]]: keyValuePair[1].value}
        }, {});

        if (!ObjectUtils.isNilOrEmpty(universalSearchField)) {
            filter = {
                ...filter,
                universalSearch: universalSearchField,
            }
        }
        searchScheduleEventEntries({
            ...filter,
            meetingRoomId,
            currentPage: currentPage,
            pageSize: pageSize,
            sortProperty: sortProperty,
            sortDirection: sortDirection,
        })
    };

    handleSearchFieldChange = (id, value) => {
        this.setState({
            searchFieldsValues: {
                ...this.state.searchFieldsValues,
                [id]: {
                    ...this.state.searchFieldsValues[id],
                    value: value
                }
            }
        })
    };

    handleUniversalSearchFieldChange = (value) => {
        this.setState({
            universalSearchField: value
        })
    };

    handleSearchSubmit = () => {
        const {
            table: {
                sort,
                pageNumber: currentPage,
                pageSize,
            }
        } = this.props;

        this.fetchData(currentPage, pageSize, sort.property, sort.direction);
    }

    handleSearchClear = () => {
        this.setState({
            universalSearchField: "",
            searchFieldsValues: Object.entries(this.state.searchFieldsValues)
                .reduce((acc, keyValuePair) => ({
                    ...acc,
                    [keyValuePair[0]]: {
                        ...keyValuePair[1],
                        value: ""
                    }
                }), {})
        })
    };

    onPageChange = (currentPage) => {
        const {
            table: {
                sort,
                pageSize,
                totalPages: pages
            }
        } = this.props;

        if (currentPage >= pages || currentPage < 0) return;

        this.fetchData(currentPage, pageSize, sort.property, sort.direction);
    }

     onPageSizeChange = (itemsPerPage) => {
        const {
            table: {
                sort,
                pageNumber: currentPage
            }
        } = this.props;

        this.fetchData(currentPage, itemsPerPage, sort.property, sort.direction);
    }

    handleSortChanged = newSort => {
        const {
            table:  {
                pageNumber,
                pageSize
            }
        } = this.props;

        const sortProperty = newSort[0].id;
        const sortDirection = newSort[0].desc? 'DESC' : 'ASC';

        this.fetchData(pageNumber, pageSize, sortProperty, sortDirection);
    }

    render() {
        const { searchFieldsValues, universalSearchField } = this.state;
        const {
            table: {
                data,
                sort,
                pageSize,
                totalPages: pages,
                pageNumber: currentPage,
                totalElements
            }
        } = this.props;

        return (
            <MeetingRoomsScheduleEvents
                searchFieldsValues={searchFieldsValues}
                universalSearchField={universalSearchField}

                handleSearchFieldChange={this.handleSearchFieldChange}
                handleUniversalSearchFieldChange={this.handleUniversalSearchFieldChange}
                handleSearchSubmit={this.handleSearchSubmit}
                handleSearchClear={this.handleSearchClear}
                handleSortChanged={this.handleSortChanged}

                data={data}
                sort={sort}
                totalElements={totalElements}
                pages={pages}
                currentPage={currentPage}
                pageSize={pageSize}
                onPageChange={this.onPageChange}
                onPageSizeChange={this.onPageSizeChange}
            />
        );
    }
}

const mapStateToProps = ({ meetingRoomsReducer }) => {
    return {
        table: meetingRoomsReducer.scheduleEventsTable
    };
};

const mapDispatchToProps = {
    searchScheduleEventEntries: actions.searchScheduleEventEntries
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MeetingRoomsScheduleEventsContainer);